<template>
  <public-layout>
    <section class="hero lvl3">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">
                Onsite Training
              </p>
              <!-- <p class="product-subtitle">
                Continuous professional development for teachers, uniquely designed to implement today’s best practices in the classroom.
              </p> -->
              <p class="product-description">
                Highlights developing key Life Skills as learning objectives.
                 Outlines a framework that uses digital devices and applications, to promote the meaningful use of
                  technology in the classroom. Gives participants an opportunity to reflect on differences, strengths and weaknesses in global education.
              </p>
              <p class="product-cta">
                <router-link class="button button-large button-secondary" :to="{ name: 'educator' }">Go Back</router-link>
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/onsite-training-big.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <hr>

    <section class="section course-info is-left-aligned">
      <div class="container">
        <div class="columns">
          <div class="column is-12">
            <div class="content">
              <h2 class="section-title has-text-centered">
                <strong>Who is the program for?</strong>
              </h2>

              <div class="container">
                <div class="columns">
                  <div class="column is-8 is-offset-one-fifth">
                  <ul>
                    <li>Early years/K-2 educators working in a classroom</li>
                    <li>Those re-entering the field/administrative level with a background in early years/K-2 education</li>
                    <li>Students in the final year of early years/primary teacher education</li>
                  </ul>
                  </div>
                </div>
              </div>

              <h2 class="section-title has-text-centered">
                <strong>Duration</strong>
              </h2>
              <div class="container">
                <div class="columns">
                  <div class="column is-8 is-offset-one-fifth">
                    <p>Six consecutive days of classes, followed by a year-long online modularised course upon further agreement.</p>
                  </div>
                </div>
              </div>

              <h2 class="section-title has-text-centered">
                <strong>On-site training modules</strong>
              </h2>
              <img id="onsiteTrainingGraph" src="/static/img/assets/onsite-training-graph.jpg" />

            </div>
          </div>
        </div>
      </div>
    </section>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import SectionContact from '@/components/SectionContact'
import Button from '@/components/Button'

export default {
  name: 'kinderpage',

  components: {
    PublicLayout,
    SectionContact,
    Button
  },

  created () {},

  data () {
    return {}
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

#onsiteTrainingGraph {
  max-width: 400px;
  width: 100%;
  display: block;
  margin: 0 auto;
  margin-top: 2.125rem;
  margin-bottom: 2.125rem;
  transform: translateX(1rem);
}

.timeline {
  .timeline-item {
    padding-left: 3rem;
    padding-bottom: 3rem;
    @include text-size-s();
    position: relative;

    &:not(:last-child)::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 0;
      border-right: 1px solid $color-gray-light;
      transform: translate(6px, calc(3.2rem + 6px));
    }

    &::after {
      content: '';
      position: absolute;
      top: 3.2rem;
      left: 0;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: $color-brand-main;
    }
  }

  .timeline-item-label {
    margin-bottom: 1rem;
    font-weight: $font-weight-semibold;
    text-transform: uppercase;
  }

  .timeline-item-title {
    margin-bottom: .5rem;
    @include text-size-xl();
    font-weight: $font-weight-semibold;
    color: $color-text-dark;
  }

  .timeline-item-description {
    margin-bottom: .5rem;
  }
}

.section-cta{
  .hero-body{
    padding-bottom: 0;
  }

  .image-wrapper{
    overflow:hidden;
    height: 400px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/OnsitePage.vue